var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { timeMetrics } from '../services';
import { checkFallbackFn } from '../utils';
export var useTimeMetrics = function (config, logger) {
    return function (params) {
        var _a = params || {}, fallback = _a.fallback, args = __rest(_a, ["fallback"]);
        if (config.isMiniApp) {
            logger.debug('[useTimeMetrics] - Using time metrics service');
            timeMetrics(args);
        }
        else if (checkFallbackFn(fallback)) {
            logger.debug('[useTimeMetrics] - Using fallback function');
            fallback(args);
        }
    };
};
